import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { INITIAL_PAGE_DEFAULT } from '../../libraries/constants';
import { paginationStyles as styles } from './styles';

const TablePaginationActions = ({ onChangePage, rowsPerPage, page, classes, count, theme }) => {
  const handleFirstPageButtonClick = event => {
    onChangePage(event, INITIAL_PAGE_DEFAULT);
  };

  const handleBackButtonClick = event => {
    onChangePage(event, page - 1);
  };

  const handleLastPageButtonClick = event => {
    onChangePage(event, Math.ceil(count / rowsPerPage) - 1);
  };

  const handleNextButtonClick = event => {
    onChangePage(event, page + 1);
  };
  return (
    <div className={classes.paginationRoot}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === INITIAL_PAGE_DEFAULT}
        aria-label="Primera Página"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === INITIAL_PAGE_DEFAULT}
        aria-label="Página Anterior"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Siguiente Página"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Última Página"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
};

TablePaginationActions.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(TablePaginationActions);
